var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentName,_vm._b({tag:"component",attrs:{"value":_vm.value},on:{"input":inputValue => _vm.$emit('input', inputValue)}},'component',_vm.$attrs,false),[_vm._l((_vm.$slots),function(_,name){return _vm._t(name,null,{"slot":name})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }